'use client';

import { sendGTMEvent } from '@next/third-parties/google';

/**
 * Sends a GTM event with optional parameters
 * 
 * @param event - The event name to send to GTM
 * @param otherParams - Optional object containing additional parameters to send with the event
 * 
 * @example
 * ```tsx
 * // Basic event
 * GTMEvent('menu_click');
 * 
 * //Event with parameters
 * GTMEvent('button_click', { 
 *   button_name: 'signup',
 *   page_location: 'homepage'
 * });
 * ```
 */
const GTMEvent = (event: string, otherParams?: Record<string, string>) => {
    sendGTMEvent({
        event: event,
        ...otherParams
    });
}

export default GTMEvent;